// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInBusinessDays as fn } from "../differenceInBusinessDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInBusinessDaysWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInBusinessDaysWithOptions;
